<template>
    <div class="order-item-option">
        <div class="order-item-option-details">
            <div class="order-item-option-name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ getName(option, props.showInternalNames) }}
            </div>
            <div class="order-item-option-price">
                <ItemPrice
                    v-if="option.singlePrice > 0"
                    class="order-item-option-price"
                    :hasDiscount="option.hasDiscount"
                    :quantity="nextMultiplier"
                    :singlePrice="option.singlePrice"
                    :singlePriceAfterDiscount="option.singlePriceAfterDiscount"
                    :discountType="option.lastDiscountType"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <OrderItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :multiplier="nextMultiplier"
                :showInternalNames="props.showInternalNames"
                :alwaysShowGroupName="props.alwaysShowGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";
    import { getName } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import ItemPrice from "./ItemPrice.vue";
    import OrderItemOptionGroup from "./OrderItemOptionGroup.vue";

    // define properties
    const props = defineProps<{
        option: IOrderItem;
        multiplier: number;
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();

    // define computed
    const nextMultiplier = computed(() => props.multiplier * props.option.quantity);
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .order-item-option {
        font-size: 12px;
        line-height: 1.666em;

        > .order-item-option-details {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;

            > .order-item-option-name {
                > .quantity {
                    display: inline-block;
                    vertical-align: top;
                    padding-right: 0.25em;
                    font-weight: 600;
                }

                flex-grow: 1;
            }

            > .order-item-option-price {
                flex: 0 0 auto;
            }
        }
        > .subs {
            padding: 0.1666em 0;
            padding-left: 1em;
        }
    }
</style>
